var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-3 ma-0",attrs:{"fluid":""}},[_c('update-name'),_c('update-password'),_c('clear-history')],1)}
var staticRenderFns = []

export { render, staticRenderFns }